import { useContext } from 'react';
import { useLocation, Link } from 'react-router-dom';

import { useChapterCompletion } from '@openclassrooms/data-connect-web/chapters';
import { getNextChapter } from '@openclassrooms/ui-web/table-of-content';
import ArrowForward from '@mui/icons-material/ArrowForward';

import CourseNavigationFooter from '../CourseNavigationFooter';
import CategoryButton from '../CategoryButton';
import CourseContext from '../../contexts/courseContext';
import CourseChapterContext from '../../contexts/courseChapterContext';
import getFooterInformation from '../../services/getFooterInformation';

const CourseFooterWrapper = () => {
  const { course, flatToc, currentUser, refetchCourseData, refetchTocData } =
    useContext(CourseContext);
  const { currentChapterId, currentChapter } = useContext(CourseChapterContext);
  const location = useLocation();
  const [, { mutateAsync: completeChapter }] = useChapterCompletion();

  if (!course) return null;

  const { categoryColor } = course;
  const nextChapter = getNextChapter(flatToc, currentChapterId);
  const { label, url } = getFooterInformation(nextChapter, course);

  const handleChapterCompletion = async () => {
    if (!currentUser) return;

    if (!currentChapter.isCompleted && currentChapterId) {
      await completeChapter(currentChapterId);
      refetchCourseData();
      refetchTocData();
    }
  };

  return (
    <CourseNavigationFooter categoryColor={categoryColor} nextChapter={nextChapter}>
      <CategoryButton
        data-testid="course-footer-button"
        to={url}
        component={Link}
        endIcon={<ArrowForward />}
        onClick={handleChapterCompletion}
        role="link"
        title={nextChapter?.title}
        state={{ from: location.pathname }}
        categoryColor={categoryColor}
      >
        {label}
      </CategoryButton>
    </CourseNavigationFooter>
  );
};

export default CourseFooterWrapper;
